import CustomerSourceType from 'sources/sourceTypes/Customer';
import { Customer } from 'types';

export const toSource = (_obj: Customer): CustomerSourceType =>
  new CustomerSourceType();

export const toType = (sourceObj: CustomerSourceType): Customer => {
  const customer = new Customer();

  customer.id = sourceObj.id;
  customer.addressId = sourceObj.address_id;
  customer.firstName = sourceObj.first_name;
  customer.lastName = sourceObj.last_name;
  customer.logo = sourceObj.logo;
  customer.name = sourceObj.name;

  return customer;
};
